module.exports = [{
      plugin: require('D:/repos/com-brianastronaut/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
